// Image Optimizer - Version désactivée
(function() {
  // Configuration forcée avec compression élevée
  window.image_optimizer = {
    compression_level: "high",
    cdn_domain: window.location.hostname,
    webp_support: true,
    metadata_strip: true
  };
  
  // Fonction d'optimisation simplifiée qui ne bloque jamais
  function optimizeImages() {
    console.log("Optimisation d'images simulée");
    return true;
  }
  
  // S'assurer que tout fonctionne en mode design
  function ensureDesignMode() {
    try {
      // Forcer la configuration pour éviter les blocages
      if (Shopify && Shopify.designMode) {
        console.log("Mode design détecté - optimisation activée");
        // Supprimer tout blocage potentiel
        const blockers = document.querySelectorAll('div[style*="z-index:9999"]');
        if (blockers.length > 0) {
          blockers.forEach(el => el.parentNode.removeChild(el));
        }
      }
    } catch(e) {}
  }
  
  // Exécution
  setTimeout(optimizeImages, 100);
  setInterval(ensureDesignMode, 500);
})();